<script lang="ts">
import { InertiaLinkType } from "@/Types/navigation";
import { Link } from "@inertiajs/inertia-vue3";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    components: { LinkVue: Link },
    props: {
        hrefRoute: {
            type: String,
            default: null,
        },
        href: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: "No title",
        },
        pageRoute: {
            type: String,
            default: null,
        },
        notALink: {
            type: Boolean,
            default: false,
        },
        uppercase: {
            type: Boolean,
            default: false,
        },
        inertiaLinkObj: {
            type: Object as PropType<InertiaLinkType>,
            default: null,
        },
    },
    emits: [],
    data: () => ({}),
    computed: {
        targetUrl(): string | undefined {
            return this.hrefRoute ? route(this.hrefRoute) : this.href || undefined;
        },
        isActiveRoute(): boolean {
            return !!this.pageRoute && this.$page.url === this.pageRoute;
        },
    },
    methods: {
        scrollToTop(): void {
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                    });
                });
            });
        },
    },
});
</script>

<template>
    <div class="nav-item">
        <a v-if="notALink" :href="targetUrl || undefined" class="nav-link text text--size-18 text--height-14 text--center text--primary-b text--semi-bold" :class="{ 'text--uppercase': uppercase }">
            {{ title }}
        </a>

        <a
            v-else-if="isActiveRoute"
            href="#"
            class="nav-link text text--size-18 text--height-14 text--center text--primary-b text--semi-bold"
            :class="{ active: isActiveRoute, 'text--uppercase': uppercase }"
            :aria-current="$page.url === '/' ? 'page' : undefined"
            @click.prevent="scrollToTop">
            {{ title }}
        </a>

        <InertiaLink
            v-else-if="inertiaLinkObj"
            class="nav-link text text--size-18 text--height-14 text--center text--primary-b text--semi-bold flex flex--valign-c flex--gap-8"
            :class="{ 'text--secondary-b': inertiaLinkObj.inertiaPowerOff }"
            :as="inertiaLinkObj.inertiaAs"
            :method="inertiaLinkObj.inertiaMethod"
            :href="targetUrl">
            {{ title }}
            <span v-if="inertiaLinkObj.inertiaPowerOff" class="fas fa-power-off"></span>
        </InertiaLink>

        <LinkVue
            v-else
            :href="targetUrl || undefined"
            class="nav-link text text--size-18 text--height-14 text--center text--primary-b text--semi-bold"
            :class="{ active: $page.url === pageRoute, 'text--uppercase': uppercase }"
            :aria-current="$page.url === '/' ? 'page' : undefined"
            :preserve-scroll="false"
            :preserve-state="false">
            {{ title }}
        </LinkVue>
    </div>
</template>

<style lang="scss" scoped></style>
